<template lang="html">
    <div id="storages-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-storageprices" v-bind:to="{ name: 'StoragePrices'}" md-label="Список"></md-tab>
            <md-tab id="tab-settings" v-bind:to="{ name: 'StoragePricesSettings'}" md-label="Настройки"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'storages-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// StoragesMenu.vue?3d42e56b